import { meta } from '../meta';
import type { WidgetPageType } from '../types';

export const WIDGET_CLASS = `eapps-${meta.appAlias}`;
export const DEMO_BEFORE_CLASS = `${WIDGET_CLASS}-demo-before`;
export const DEMO_CONTROLS_CLASS = `${WIDGET_CLASS}-demo-controls`;
export const DEMO_CONTENT_FOCUS_SELECTOR =
  '[data-eapps-accessibility-demo-container]';
export const FORCED_FOCUS_VISIBLE_ATTRIBUTE = 'data-eapps-force-focus-visible';
export const EXCLUSION_RELATED_CLASSES = [
  WIDGET_CLASS,
  DEMO_BEFORE_CLASS,
  DEMO_CONTROLS_CLASS
] as const;
export const DEFAULT_PAGE: WidgetPageType = 'main';

export const TEXT_TAGS = [
  'div',
  'span',
  'a',
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'mark',
  'small',
  'del',
  'ins',
  'sub',
  'sup',
  'code',
  'pre',
  'blockquote',
  'q',
  'abbr',
  'cite',
  'dfn',
  'kbd',
  'var',
  'address',
  'time',
  's',
  'wbr',
  'button'
];
